import {Injectable} from '@angular/core';
import {LargeStorageLocal} from '@app/core/shared/domain/storage/large-storage.local';

@Injectable()
export class LargeStorageLocalStorage implements LargeStorageLocal {

    public getItem(key: string): string | null {
        return window.localStorage.getItem(key);
    }
    public setItem(key: string, value: any): void {
        window.localStorage.setItem(key, value);
    }
    public removeItem(key: string): void {
        window.localStorage.removeItem(key);
    }
    public clear(): void {
        window.localStorage.clear();
    }
    
}
